export const parseDateValue = (date: Date | string) => {
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return date ? date.toISOString().split('T')[0] : '';
};
